module.exports = __webpack_public_path__ + "media/images/maps/pins/digi_pin-8703c940ed3e3678f4121b43e26e88e3.png";